"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const updateProgressMeasure_1 = require("./updateProgressMeasure");
function evaluateChannel(command, user, content, states) {
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const progressMeasureEvents = updateProgressMeasure_1.updateProgressMeasure(command, user, content, draftStates, false);
        events.push(...progressMeasureEvents);
    });
    return { events, states: updatedStates, stateInteractions: [] };
}
exports.evaluateChannel = evaluateChannel;
//# sourceMappingURL=evaluateChannelCard.js.map